module.exports = __webpack_public_path__ + "static/media/Sal.67403ef6.jpg";